/*
 * AI search analytics. Anonymous, fail-soft. Logs settled searches (debounced),
 * result clicks (delegated), and search-sourced add-to-cart (fetch-wrap) to the
 * Worker's /api/events. Last-touch attribution via a localStorage search-sourced
 * map (30-min TTL). Exposes window.AISearchAnalytics.logSearch(query,count,surface).
 */
var XORIGIN_KEY = 'nai_xorigin', XTTL = 7 * 24 * 60 * 60 * 1000;
// Pure: parse search for _nax/_naxs, persist with TTL, return {sid,src,ts} or null.
function readOrigin(search, now, ls) {
  try {
    var m = /[?&]_nax=([^&]+)/.exec(search || '');
    if (m && m[1]) {
      var srcM = /[?&]_naxs=([^&]+)/.exec(search || '');
      var o = { sid: decodeURIComponent(m[1]).slice(0, 64),
                src: (srcM && srcM[1] ? decodeURIComponent(srcM[1]) : '').slice(0, 32) || 'unknown',
                ts: now };
      if (ls) { try { ls.setItem(XORIGIN_KEY, JSON.stringify(o)); } catch (e) {} }
      return o;
    }
    if (ls) {
      var raw = ls.getItem(XORIGIN_KEY); if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || typeof p.ts !== 'number' || (now - p.ts) > XTTL) return null;
      return p;
    }
  } catch (e) {}
  return null;
}

// Pure: fire the landing only once per origin sid (avoids re-firing on refresh /
// back-forward when _nax stays in the URL).
function shouldFireLanding(sid, lastFired) { return !!sid && lastFired !== sid; }

if (typeof window !== 'undefined') {
(function () {
  var cfg = window.AISearch || {};
  var SID_KEY = 'nai_sid', MAP_KEY = 'nai_src';
  var TTL = 30 * 60 * 1000, DEDUPE_MS = 5000, LOG_DEBOUNCE_MS = 800;
  var RECENT_KEY = 'nai_recent', RECENT_MAX = 6;

  function ready() { return !!(cfg.enabled && cfg.url && cfg.tenant); }
  function uuid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'x' + Date.now() + '-' + Math.floor(Math.random() * 1e9);
  }
  function store() { try { return window.localStorage; } catch (e) { return null; } }
  function sessionId() {
    var ls = store(); if (!ls) return 'nostore';
    var s = ls.getItem(SID_KEY); if (!s) { s = uuid(); try { ls.setItem(SID_KEY, s); } catch (e) {} } return s;
  }
  function endpoint() { return cfg.url.replace(/\/+$/, '') + '/api/events?tenant=' + encodeURIComponent(cfg.tenant); }
  function post(events) {
    if (!ready()) return;
    try {
      var body = JSON.stringify({ events: events });
      if (navigator.sendBeacon) {
        // Send as text/plain (a CORS-safelisted content type). sendBeacon cannot
        // perform a CORS preflight, so an application/json body would be silently
        // dropped cross-origin. The Worker parses the JSON body regardless.
        navigator.sendBeacon(endpoint(), body);
      } else {
        fetch(endpoint(), { method: 'POST', body: body, headers: { 'Content-Type': 'text/plain' }, keepalive: true });
      }
    } catch (e) {}
  }

  function getMap() { var ls = store(); if (!ls) return {}; try { return JSON.parse(ls.getItem(MAP_KEY) || '{}'); } catch (e) { return {}; } }
  function setMap(m) { var ls = store(); if (!ls) return; try { ls.setItem(MAP_KEY, JSON.stringify(m)); } catch (e) {} }
  function prune(m) { var now = Date.now(); for (var k in m) { if (!m[k] || now - m[k].ts > TTL) delete m[k]; } return m; }
  function markSourced(handle, searchId) { if (!handle) return; var m = prune(getMap()); m[handle] = { search_id: searchId, ts: Date.now() }; setMap(m); }
  function sourcedSearchId(handle) { var m = prune(getMap()); setMap(m); return m[handle] ? m[handle].search_id : null; }

  // Recent searches (most-recent-first, deduped, capped) for discovery UI.
  function recordRecent(q) {
    var ls = store(); if (!ls || !q) return;
    try {
      var arr = JSON.parse(ls.getItem(RECENT_KEY) || '[]');
      arr = arr.filter(function (x) { return String(x).toLowerCase() !== q.toLowerCase(); });
      arr.unshift(q);
      ls.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, RECENT_MAX)));
    } catch (e) {}
  }
  function getRecent() { var ls = store(); if (!ls) return []; try { return JSON.parse(ls.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }

  var current = null;        // {search_id, query, surface}
  var lastLogged = {};       // dedupe key -> ts
  var debTimer = null;

  function logSearch(query, resultCount, surface) {
    var q = (query || '').trim();
    if (q.length < 2 || !ready()) return;
    surface = surface || '';
    // Set `current` (with a search_id) SYNCHRONOUSLY so a click that happens
    // before the debounce fires is still attributed. Reuse the same id while the
    // (query, surface) is unchanged, so the debounced search event and the click
    // share one search_id (the metrics join is set-based, so order doesn't matter).
    if (!current || current.query !== q || current.surface !== surface) {
      current = { search_id: uuid(), query: q, surface: surface };
    }
    var sid = current.search_id;
    var resCount = (typeof resultCount === 'number' ? resultCount : null);
    clearTimeout(debTimer);
    debTimer = setTimeout(function () {
      var key = surface + '|' + q.toLowerCase();
      var now = Date.now();
      if (lastLogged[key] && now - lastLogged[key] < DEDUPE_MS) return;
      lastLogged[key] = now;
      recordRecent(q);
      post([{ event_type: 'search', session_id: sessionId(), search_id: sid, query: q,
              result_count: resCount, surface: surface }]);
    }, LOG_DEBOUNCE_MS);
  }

  function logClick(handle, kind, position, surface) {
    if (!ready() || !handle) return;
    var searchId = current ? current.search_id : null;
    markSourced(handle, searchId);
    post([{ event_type: 'click', session_id: sessionId(), search_id: searchId,
            item_id: handle, item_kind: kind || '', position: position || null, surface: surface || '' }]);
  }

  // Delegated click logging for any AI result link.
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      var a = t && t.closest ? t.closest('[data-ai-result]') : null;
      if (!a) return;
      logClick(a.getAttribute('data-ai-item'), a.getAttribute('data-ai-kind'),
               Number(a.getAttribute('data-ai-position')) || null, a.getAttribute('data-ai-surface') || '');
    } catch (err) {}
  }, true);

  // Stamp the anonymous session id onto the cart as an attribute so the
  // checkout web pixel (sandboxed; cannot read localStorage) can attribute
  // purchases back to this session. Once per page lifecycle, after a cart-add.
  var cartAttrSet = false;
  function ensureCartAttribute() {
    if (cartAttrSet || !ready()) return;
    cartAttrSet = true;
    try {
      var attrs = { _nai_sid: sessionId() };
      var o = readOrigin('', Date.now(), store());   // read persisted (no new param)
      if (o && o.sid) { attrs._nai_xsid = o.sid; attrs._nai_xsrc = o.src; }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
      }).catch(function () {});
    } catch (e) {}
  }

  // Cart-add detection via fetch wrap (last-touch attribution).
  function handleCartAdd(data) {
    try {
      var items = data && data.items ? data.items : (data ? [data] : []);
      items.forEach(function (it) {
        var handle = it && it.handle; if (!handle) return;
        var searchId = sourcedSearchId(handle); if (!searchId) return;
        var cents = (typeof it.final_line_price === 'number') ? it.final_line_price
                  : (typeof it.price === 'number' ? it.price : null);
        post([{ event_type: 'cart', session_id: sessionId(), search_id: searchId,
                item_id: handle, value: cents != null ? cents / 100 : null }]);
      });
    } catch (e) {}
  }
  if (window.fetch && !window.__aiCartWrapped) {
    window.__aiCartWrapped = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = '';
      try { url = (arguments[0] && arguments[0].url) ? arguments[0].url : String(arguments[0] || ''); } catch (e) {}
      var p = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        try {
          p.then(function (res) { res.clone().json().then(handleCartAdd).catch(function () {}); ensureCartAttribute(); }).catch(function () {});
        } catch (e) {}
      }
      return p;
    };
  }

  // Generic event for non-search prompts (e.g. replenishment) and experiment
  // exposures. Session id is added here; every other field on `partial` passes
  // through verbatim (Object.assign copies all own enumerable keys, nothing is
  // stripped), so callers can forward arbitrary fields such as
  // feature / experiment_id / variant / props. Used by exp-engine.js exposure.
  function track(partial) {
    try { post([Object.assign({ session_id: sessionId() }, partial || {})]); } catch (e) {}
  }

  window.AISearchAnalytics = {
    logSearch: logSearch, logClick: logClick, sessionId: sessionId, getRecent: getRecent,
    track: track, markSourced: markSourced,
  };

  (function initOrigin() {
    try {
      var hadParam = /[?&]_nax=/.test(location.search);
      var o = readOrigin(location.search, Date.now(), store());
      if (o && hadParam && window.AISearchAnalytics && window.AISearchAnalytics.track) {
        var ls = store();
        var lastFired = ls ? ls.getItem('nai_xorigin_fired') : null;
        if (shouldFireLanding(o.sid, lastFired)) {
          window.AISearchAnalytics.track({ event_type: 'xstore_landing', surface: 'cross-store',
            props: JSON.stringify({ origin_session: o.sid, origin_tenant: o.src }) });
          if (ls) { try { ls.setItem('nai_xorigin_fired', o.sid); } catch (e) {} }
        }
      }
    } catch (e) {}
  })();
})();
}

if (typeof module !== 'undefined' && module.exports) module.exports = { readOrigin, shouldFireLanding };
